import { NavLogo } from './NavbarElements'
import { Link } from 'react-scroll'
import { CgFormatRight } from "react-icons/cg";
import './Navbar.css'

const index = ({ toggle }) => {
  return (
    <div className='Nav'>
        <div className='NavbarContainer'>
            <NavLogo to='/'>
                <div className='Navlogo' />
            </NavLogo>
             <div className='MobileIcon' onClick={toggle}>
                    <CgFormatRight />
            </div>
            
            <ul className='nav-links'>
                <li>
                    <NavLogo to='/menu'>
                        Menu
                    </NavLogo>
                </li>
                <li>
                    <Link to='about' smooth={true} duration={2000} offset={-110} className='NavLinks'>
                        About us
                    </Link>
                </li>                
                <li>
                    <Link to='contact' smooth={true} duration={2000} offset={-110} className='NavLinks'>
                        Contact us
                    </Link>
                </li>
                 <li>
                    <a href='https://billetto.se/e/vocco-night-access-biljetter-2027863?utm_source=organiser&utm_medium=share&utm_campaign=copy_link&utm_content=2' className='NavLinks'>
                        Buy tickets
                    </a>
                </li> 
                <li>
                    <Link to='booking' smooth={true} duration={1800} className='NavLinks'>
                        Book table
                    </Link>
                </li>   
            </ul>
        </div>
    </div>
  )
}

export default index